import { db } from "../utils/firebase";
import { collection, getDocs } from "firebase/firestore";

export const GetProposals = async () => {
  var proposals = [];
  await getDocs(collection(db, "Proposals")).then((docs) =>
    docs.forEach((doc) => {
      proposals.push(doc.data());
    })
  );
  return proposals;
};
